import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { SystemService } from "common/services/core-services/system.service";
import { NotificationModel } from "common/models/page-models/notification/notification-data.model";
import { NotificationMetaModel } from "common/models/page-models/notification/notification-form-meta.model";
import { NotificationFormDataService } from "common/services/data-services/admin/notification/notification-form-data.service";
import { GroupsGridDataService } from "common/services/data-services/admin/groups/groups-grid-data.service";
import { BranchesGridDataService } from "common/services/data-services/admin/branches/branches-grid-data.service";
import { MentorBatchListDataService } from "common/services/data-services/custom-service/mentor-batch-service";
import { StudentsGridDataService } from "common/services/data-services/admin/students/students-grid-data.service";
import { EmailTemplateListDataService } from "common/services/data-services/custom-service/email-template-list.service";
import moment from "moment";
import { TokenService } from "common/services/core-services/get-token.service";
import { BatchListDataService } from "common/services/data-services/custom-service/batch-service";
import { zoneListDataService } from "common/services/data-services/custom-service/zoneList-service";

@Injectable({
    providedIn: 'root'
})
export class NotificationFormWidgetService extends FormWidgetService<NotificationModel> {
    studentList: any = [];
    groupList: any = [];
    batchList: any = [];
    constructor(protected ds: NotificationFormDataService, private batchListService: BatchListDataService, private branchListService: BranchesGridDataService, private groupListService: GroupsGridDataService, private studentService: StudentsGridDataService, private emailTemplateList: EmailTemplateListDataService, private zoneListService: zoneListDataService, private systemService: SystemService, private tokenService: TokenService,
    ) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new NotificationMetaModel();
        return meta.getMetaModel();
    }


    override prepareMetaModel(dataModel: NotificationModel, metaModel: NotificationMetaModel, routeData: WidgetModel, event: any = null): Promise<NotificationMetaModel> {
        return new Promise<NotificationMetaModel>((resolve, reject) => {







            metaModel.pageTitle = dataModel.announcement_id && dataModel.announcement_id !== "" ? 'Edit notification' : 'Add notification';
            if (routeData.transferData.navPageType === "View notification") {
                metaModel.pageTitle = 'View notification';

                metaModel.properties.announcement_datetime.readOnly = true;
                metaModel.properties.announcement_datetime.propreadOnly = true;

                metaModel.properties.buttons.submit.isHideButton = true;
            }

            if (dataModel.announcement_id !== "") {
                metaModel.properties.announcement_datetime.readOnly = true;
                metaModel.properties.announcement_datetime.propreadOnly = true;
            }


            if (dataModel.announcement_id !== 0) {
                metaModel.properties.announcement_type.propreadOnly = true;
                metaModel.properties.announcement_type.readOnly = true;
                metaModel.properties.template_id.propreadOnly = false;
                metaModel.properties.template_id.readOnly = false;
                metaModel.properties.send_to.propreadOnly = true;
                metaModel.properties.send_to.readOnly = true;
            }



            const tokenDetails = this.tokenService.getDetailsFromToken(localStorage.getItem('token'));
            const payload = {
                user_id: tokenDetails['tokenData'].id
            };

            this.emailTemplateList.postData(payload).then((data) => {
                metaModel.properties.template_id.options = data.details;
            });
            this.zoneListService.postData('').then((data) => {

                dataModel['region_options'] = data.details
            });



            this.batchListService.postData('').then((data) => {
                metaModel.properties['batch_id'].options = data.details;
            });
            this.branchListService.postData('').then((data) => {
                metaModel.properties['branch_id'].options = data.details;
            })
            this.groupListService.postData('').then((data) => {
                if (dataModel.id && dataModel.id !== "") {
                    metaModel.properties['group_id'].options = data.details.filter((group) => group.batch_id === dataModel.batch_id)

                }

                routeData.transferData.groups = data.details
            });
            this.studentService.postData('').then((data) => {
                if (dataModel.id && dataModel.id !== "") {
                    metaModel.properties['student_ids'].options = data.details.filter((student) => student.batch_id == dataModel.batch_id && student.status == 1 || student.status == 3);
                }

                routeData.transferData.students = data.details
            });

            resolve(metaModel);

        });
    }



}
